      function hasavalable(jsonData) {
        	if (!jsonData) return false;

          if (typeof jsonData === 'string') {
            try {
               jsonData = JSON.parse(jsonData);
              } catch (e) {
                return false;
            }
					}

          if (!jsonData.objects || !Array.isArray(jsonData.objects)) return false;

					const hasRect = jsonData.objects.some(obj => obj.type === 'rect');
					const moreThanOne = jsonData.objects.length > 1;

					return hasRect && moreThanOne;
        
      }




const edit_btn = document.querySelectorAll('[edit_btn]');
if (edit_btn) {
  edit_btn.forEach(item => {
    item.addEventListener("click", function () {
      const attr = item.getAttribute('edit_btn');
      // console.log("att",attr);
      document.querySelector('[store_data="'+ attr +'"]').classList.add('hidden');
      document.querySelector('[new_data_edit="'+ attr +'"]').classList.remove('hidden');
      const removehtml = document.querySelector('.selected-product-wrapper');
      const removeinputvalue = document.querySelector('.new-outfit-selected-search.field .field__input');
      const disableremovenew =  document.querySelector('.new-save-btn');
      const shownewbutton = document.querySelector('.btn-save');
      if (removehtml && removeinputvalue && disableremovenew && shownewbutton) {
        removehtml.innerHTML = '';
        removeinputvalue.value = '';
        shownewbutton.disabled = true;
        shownewbutton.style.display = 'block';
        disableremovenew.style.display = 'none';
      document.querySelectorAll('.btn-html-add').forEach((btn) => {
        btn.disabled = false;
      });
      }
    });
  });
}


const edit_btn_ = document.querySelectorAll('[data-back-prosnolisetion]');
if (edit_btn_) {
  edit_btn_.forEach(item => {
    item.addEventListener("click", function () {
      const hide_new = document.querySelector("[new_data_edit='outfit']") || null;
      const hide_new_main_pros = document.querySelector("#main-angular_product_wapper") || null;
      if(hide_new) hide_new.classList.remove('hidden');
      if(hide_new_main_pros)hide_new_main_pros.classList.add('hidden');
    });
  });
}

const back_btn = document.querySelectorAll('[back-btn]');
if (back_btn) {
  back_btn.forEach(item => {
    item.addEventListener("click", function () {
      const attr = item.getAttribute('back-btn');
      // console.log("att",attr);
      document.querySelector('[new_data_edit="'+ attr +'"]').classList.add('hidden');
      document.querySelector('[store_data="'+ attr +'"]').classList.remove('hidden');
      
      const parent_div = item.closest('[card-form-wrapper]');
      if (parent_div) {
        
      const allPersonForms = parent_div.querySelectorAll('[person_id]');
      if (allPersonForms) {
      allPersonForms.forEach(el => {
        if (!el.classList.contains('hidden')) {
          el.classList.add('hidden');
        }
      });
      }
      }
      
    });
  });
}

// if (document.getElementById('people_data')) {

// document.getElementById('people_data').addEventListener('submit', function (e) {
//   e.preventDefault();

//   const form = e.target;
//   const formData = new FormData(form);
//   const metfilds_key = 'person';
//   const formFields = {};

//   // Convert form data to object
//   formData.forEach((value, key) => {
//     formFields[key] = value;
//   });

//   // Get existing data array or initialize empty
//   const existingData = JSON.parse(localStorage.getItem('peopel_data')) || [];

//   // Calculate next id as string (length + 1)
//   const nextId = Math.floor(Math.random() * 1000000).toString();

//   // Prepare new entry with profile empty object
//   const newEntry = {
//     id: nextId,
//     profile: {},
//     ...formFields
//   };

//   // Add new entry to existing array
//   existingData.push(newEntry);

//   // Save back to localStorage
//   localStorage.setItem('peopel_data', JSON.stringify(existingData));
//   // localStorage.setItem('peopel_data_1111', JSON.stringify(existingData));

//   // Debug log
//   console.log('Updated Form Data:', existingData);

//   // Call your upload function with array data
//   people_data_upload(existingData,metfilds_key);

//   // Reset the form after submission
//   form.reset();
// });
// }

const edit_btn_card = document.querySelectorAll('[edit_card_btn]');
if (edit_btn_card) {
  edit_btn_card.forEach(item => {
    item.addEventListener("click", function () {
      const attr = item.getAttribute('person_form');
      console.log("att", attr);

      const parent_div = item.closest('[card-form-wrapper]');
      const storeData = parent_div.querySelector('[store_data]');
      if (storeData) storeData.classList.add('hidden');

      // Hide all person_id sections inside this parent
      const allPersonForms = parent_div.querySelectorAll('[person_id]');
      if (allPersonForms) {
        
      allPersonForms.forEach(el => {
        if (!el.classList.contains('hidden')) {
          el.classList.add('hidden');
        }
      });
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      // Show the selected person_id section
      const targetForm = parent_div.querySelector(`[person_id="${attr}"]`);
      if (targetForm) targetForm.classList.remove('hidden');
    });
  });
}


 
// ==================outfit hide show collections products======

const collecclick = document.querySelectorAll('.category-list a');
if (collecclick) {


collecclick.forEach(link => {
  link.addEventListener("click", function (e) {
    e.preventDefault();
    const datatitle = link.getAttribute('data-title');
    collecclick.forEach(l => l.classList.remove('active'));
    link.classList.add('active');
    const allGrids = document.querySelectorAll('.new-outfit-collection-wrapper');
    allGrids.forEach(grid => grid.classList.remove('active'));

    const matchingGrids = document.querySelectorAll(`.new-outfit-collection-wrapper[data-content="${datatitle}"]`);
    matchingGrids.forEach(grid => grid.classList.add('active'));
  });
});

}


const searchInput = document.querySelector('.new-outfit-selected-search.field input');
const btnhtml = document.querySelectorAll('.btn-html-add');
const btnSave = document.querySelector('.btn-save');

function removeDisabledFromSaveBtns() {
  setTimeout(() => {
    const searchInput = document.querySelector('.new-outfit-selected-search.field .field__input');
    const selectedItems = document.querySelector('.selected-product-wrapper');

    const hasSearchText = searchInput && searchInput.value.trim() !== '';
    const hasContent = selectedItems && selectedItems.innerHTML.trim() !== '';

    const saveButtons = document.querySelectorAll('.new-save-btn');

    saveButtons.forEach(btn => {
      if (hasSearchText && hasContent) {
        btn.removeAttribute('disabled');
      } else {
        btn.setAttribute('disabled', 'true');
      }
    });
  }, 100);
}


// if (btnhtml.length > 0) {
  // btnhtml.forEach(function (btn) {
  //   btn.addEventListener('click', function () {
  //     const htmlString = this.getAttribute('data-html');
  //     const container = document.querySelector('.selected-product-wrapper');
  //     removeDisabledFromSaveBtns();
  //     if (container) {

  //         update_angular(htmlString,container);
  //       // container.insertAdjacentHTML('beforeend', htmlString);

  //       // Disable only the buttons in this specific wrapper
  //       const wrapper = this.closest('.new-outfit-collection-wrapper');
  //       if (wrapper) {
  //         const buttonsInWrapper = wrapper.querySelectorAll('.btn-html-add');
  //         buttonsInWrapper.forEach(b => b.disabled = true);
  //       }
  //     }
  //   });
  // });


  function add_productonright(this_){
      const htmlString = this_.getAttribute('data-html');
      const container = document.querySelector('.selected-product-wrapper');
    
      removeDisabledFromSaveBtns();
      if (container) {

          update_angular(htmlString,container);
        // container.insertAdjacentHTML('beforeend', htmlString);

        // Disable only the buttons in this specific wrapper
        const wrapper = this_.closest('.new-outfit-collection-wrapper');
        if (wrapper) {
          wrapper.classList.add("outfit_selected");
          const buttonsInWrapper = wrapper.querySelectorAll('.btn-html-add');
          buttonsInWrapper.forEach(b => b.disabled = true);
        }
      }
      const btnsavedis = document.querySelector('.btn-save');
      if(btnsavedis){
        btnsavedis.disabled = false;
      }
  }



  const container = document.querySelector('.selected-product-wrapper');
  if (container) {
    container.addEventListener('click', function (e) {
      const removeBtn = e.target.closest('.remove-card');
      if (removeBtn) {
      
       removeDisabledFromSaveBtns();
        const item = removeBtn.closest('.selected-product-item');
        const dataValue = removeBtn.getAttribute('data-content-remove');

        if (item) item.remove();

        // Find the matching wrapper
        const matchingWrapper = document.querySelector(`.new-outfit-collection-wrapper[data-content="${dataValue}"]`);
        if (matchingWrapper) {
          matchingWrapper.classList.remove("outfit_selected");
          const buttonsInWrapper = matchingWrapper.querySelectorAll('.btn-html-add');
          buttonsInWrapper.forEach(b => b.disabled = false);
        }
      }
    });
  }
// }

function update_angular(params,container) {
     // 1. Get the AngularJS app element
    var appElement = document.querySelector('[ng-app]');
    
    // 2. Get the AngularJS injector
    var injector = angular.element(appElement).injector();
    
    // 3. Get the $compile and $rootScope services
    var $compile = injector.get('$compile');
    var $rootScope = injector.get('$rootScope');
    
    // 4. Create a new child scope (inherits controller functions if needed)
    var newScope = $rootScope.$new(); // Don't use isolated scope (true) if you need controller methods
    
    // 5. If your controller is registered on a specific element and you need its scope:
    var controllerElement = document.querySelector('[ng-controller="ProductCtrl"]');
    if (controllerElement) {
      var controllerScope = angular.element(controllerElement).scope();
      newScope.loadProductchange = controllerScope.loadProductchange;
    }      
    // 7. Compile and append
    var compiled = $compile(params)(newScope);
    // document.getElementById('external-container').appendChild(compiled[0]);
      container.appendChild(compiled[0]);
    
    // 8. Apply scope to trigger bindings
    newScope.$apply();
  
}


// if (btnSave) {
//  btnSave.addEventListener('click', function () {
//   const productCards = document.querySelectorAll('.new-outfit-selected-block .selected-product-card');
//   const inputname = document.querySelector('.new-outfit-selected-block .field__input')?.value || '';
//   const randomId = Math.floor(Math.random() * 1000000);
// const tempOutput = {};

// productCards.forEach((card, index) => {
//   const imageWrapper = card.querySelector('.selected-product-image');
//   const quantityInput = card.querySelector('.quantity__input');

//   const productData = {
//     id: index + 1,
//     Categoryname: imageWrapper?.getAttribute('data-collection-title') || '',
//     variant_id: imageWrapper?.getAttribute('data-variant-id') || '',
//     product_handle: imageWrapper?.getAttribute('data-product-handle') || '',
//     quantity: quantityInput?.value || ''
//   };

//   tempOutput[(index + 1).toString()] = productData;
// });

// // Reconstruct finalOutput with id and name at the top
// const finalOutput = {
//   id: randomId,
//   name: inputname,
//   ...tempOutput
// };

// console.log('finalOutput', finalOutput);
// });



// }


if (btnSave) {
  btnSave.addEventListener('click', function () {
    
    const productCards = document.querySelectorAll('.new-outfit-selected-block .selected-product-card');
    const inputname = document.querySelector('.new-outfit-selected-block .field__input')?.value || '';
    const randomId = Math.floor(Math.random() * 1000000);
    const metfilds_key = 'outfit';
    const existingData = JSON.parse(localStorage.getItem("customProductSets")) || [];

      const inputEl = document.querySelector('.new-outfit-selected-search.field input');
    const inputnamew = inputEl?.value.trim() || '';

    const outfitnamepopup = document.querySelector('.popup-outfit-name');

    // ❌ If input is empty → show popup & STOP
    if (!inputnamew) {
      if (outfitnamepopup) {
        outfitnamepopup.classList.add('active');
        document.querySelector('body').classList.add('popup-outfit-name-show');
      }
      return; // ⛔ stop execution here
    }
    
    const singleOutput = {
      id: randomId,
      name: inputname,
     
    };

    productCards.forEach((card, index) => {
      let json_main_produtc_obect = {}
    let json_main_produtc_image = {}
    let json_main_produtc_Veredelung = {}
    

      const imageWrapper = card.querySelector('.selected-product-image');
      const quantityInput = card.querySelector('.quantity__input');
      const colle_url = card.querySelector('.edit-product')?.getAttribute('data-collection-url') || '';
      const page_url = card.querySelector('.edit-product')?.getAttribute('href') || '';
      const main_json_objct =  card.querySelector('[data-customize')?.getAttribute('data-customize') || null;
      const main_json_image =  card.querySelector('[data-customize-final-images')?.getAttribute('data-customize-final-images') || null;
      const main_json_Veredelung =  card.querySelector('[data-customize-final-Veredelung')?.getAttribute('data-customize-final-Veredelung') || null;
      if(main_json_objct){
         json_main_produtc_obect = JSON.parse(main_json_objct);
      }
      if(main_json_image){
         json_main_produtc_image =  main_json_image;
      }
      if(main_json_Veredelung){
            // json_main_produtc_Veredelung = main_json_Veredelung
            json_main_produtc_Veredelung = JSON.parse(main_json_Veredelung); 
      }
      const productData = {
        id: index + 1,
        kategorynam: imageWrapper?.getAttribute('data-collection-title') || '',
        customize_id: imageWrapper?.getAttribute('data-prosnolize-id') || '',
        varent_id: imageWrapper?.getAttribute('data-variant-id') || '',
        product_heandle: imageWrapper?.getAttribute('data-product-handle') || '',
        qtu: quantityInput?.value || '',
        collection_url : colle_url,
        page_url: page_url,
        product_custom_image: json_main_produtc_image || null,
        product_custom_oject: json_main_produtc_obect || null,
        product_custom_Veredelung: json_main_produtc_Veredelung || null,
      };

      singleOutput[(index + 1).toString()] = productData;
    });
    
 

    existingData.push(singleOutput);


    localStorage.setItem("customProductSets", JSON.stringify(existingData));

    people_data_upload(existingData,metfilds_key);
    const successmess = document.querySelector('.popup-success');
    if (successmess) {
      // Hide the popup after 3 seconds (3000 milliseconds)
      setTimeout(() => {
          successmess.classList.add('active');
      }, 2000);
    }
    
  });
}
// ------------------- success mess popup
const closesuccs = document.querySelectorAll('.popup-success .popup-overlay-inner ,.popup-success-inner .close');
if (closesuccs) {
  
closesuccs.forEach(el => {
  el.addEventListener('click', function () {
    const popupDiv = document.querySelector('.popup-success');
    popupDiv.classList.remove('active');
    const back_btnn = document.querySelector('[back-btn]');
    
      window.location.reload();
      // if (document.body.classList.contains('new-people-success-popup-show')) {
      //   document.body.classList.remove('new-people-success-popup-show');
      // }
    
    
    back_btnn.click();
  });
});
}
// if (searchInput) {

//   searchInput.addEventListener('input', function () {
  
//     removeDisabledFromSaveBtns();
//   });
// }


const resetdata = document.querySelector('.btn-cancel');

if (resetdata) {
  resetdata.addEventListener('click', function () {
    const removeItems = document.querySelectorAll('.selected-product-item-wrp-sec.selected-product-item'); 
    searchInput.value = '';
    btnhtml.forEach(b => b.disabled = false);
    removeItems.forEach(items => {
      items.remove(); 
    });
    const backtiggerr = document.querySelector('.curated-outfit .back-btn');
      if(backtiggerr){
        backtiggerr.click();
      }
  });
}


// ==================edit button click====

const editClick = document.querySelectorAll('.btn-edit');

editClick.forEach(button => {
  button.addEventListener('click', function () {
    // 1. Set the set name
    const setnameget = this.getAttribute('data-set-name');
    const inputvalueadd = document.querySelector('.new-outfit-selected-search.field .field__input');
    if (setnameget && inputvalueadd) {
      inputvalueadd.value = setnameget;
    }

    // 2. Get the closest item and insert product HTML
    const closestItem = this.closest('.grid__item.curated-outfit-product-item');
    if (!closestItem) return;

    const allImages = closestItem.querySelectorAll('[data-get-customize-html]') || null;
    if (!allImages.length) return;

    const htmlAdd = document.querySelector('.selected-product-wrapper');
    if (!htmlAdd) return;

    htmlAdd.innerHTML = '';
    const collectionNames = new Set();

    allImages.forEach(img => {
      const htmlString = img.innerHTML;
      const colName = img.querySelector('.selected-product-image').getAttribute('data-collection-title');
      if (colName) {
        collectionNames.add(colName);
      }
      if (htmlString) {

        update_angular(htmlString,htmlAdd);
        
        // htmlAdd.insertAdjacentHTML('beforeend', htmlString);
      }
    });
    console.log(collectionNames,"collectionNames")
    
    // 3. Replace only the .btn-save inside .selected-product-action-btns
    const saveHtml = this.getAttribute('data-save-html');
    console.log(saveHtml,"saveHtml")
    if (saveHtml) {
      const wrapper = document.querySelector('.new-outfit-selected-wrapper');
        if (wrapper) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = saveHtml;
        
          const newSaveBtn = tempDiv.querySelector('.btn-save') || tempDiv.querySelector('button');
          const oldSaveBtn = wrapper.querySelector('.selected-product-action-btns .btn-save');
          const existingNewSaveBtn = wrapper.querySelector('.selected-product-action-btns .new-save-btn'); // navi button ne identify karva class
        
          if (newSaveBtn && oldSaveBtn) {
            newSaveBtn.classList.add('new-save-btn');
        
            if (existingNewSaveBtn) {
              existingNewSaveBtn.replaceWith(newSaveBtn);
            } else {
              oldSaveBtn.insertAdjacentElement('afterend', newSaveBtn);
              oldSaveBtn.style.display = 'none';
            }
          }
        }

    }
 removeDisabledFromSaveBtns();

   // Disable buttons that match collection names
    const allAddBtns = document.querySelectorAll('.new-outfit-collection-item.grid__item .btn-html-add');
    allAddBtns.forEach(btn => {
      const btnColName = btn.getAttribute('data-new-outfit-name');
      if (collectionNames.has(btnColName)) {
        //btn.setAttribute('disabled', 'disabled');
      } else {
        btn.removeAttribute('disabled');
      }
    });
   const edit_btn = document.querySelectorAll('[edit_btn]');
    if (edit_btn) {
      edit_btn.forEach(item => {
    
          const attr = item.getAttribute('edit_btn');
          document.querySelector('[store_data="'+ attr +'"]').classList.add('hidden');
          document.querySelector('[new_data_edit="'+ attr +'"]').classList.remove('hidden');
      

      });
    }
    // 4. Trigger the final button click
    // const editTrigger = document.querySelector('.new-btn a');
    // if (editTrigger) {
    //   editTrigger.click();
    // }
  });
});


document.addEventListener('click', function (e) {
  if (e.target.classList.contains('new-save-btn')) {
    const btnSave = e.target;
    const setId = parseInt(btnSave.getAttribute('data-set-id')); // Existing set ID
    const productCards = document.querySelectorAll('.new-outfit-selected-block .selected-product-card');
    const inputname = document.querySelector('.new-outfit-selected-block .field__input')?.value || '';
    const metfilds_key = 'outfit';

    const newinputEl = document.querySelector('.new-outfit-selected-search.field input');
    const inputnamenew = newinputEl?.value.trim() || '';

    const outfitnamepopupnew = document.querySelector('.popup-outfit-name');

    // ❌ If input is empty → show popup & STOP
    if (!inputnamenew) {
      if (outfitnamepopupnew) {
        outfitnamepopupnew.classList.add('active');
        document.querySelector('body').classList.add('popup-outfit-name-show');
      }
      return; // ⛔ stop execution here
    }
    

    // Load existing sets
    const existingData = JSON.parse(localStorage.getItem("customProductSets")) || [];
    // Find the matching set by ID
    const setIndex = existingData.findIndex(set => set.id === setId);
    if (setIndex === -1) {
      console.warn('Set ID not found in localStorage:', setId);
      return;
    }

    const updatedSet = {
      id: setId,
      name: inputname
    };

    productCards.forEach((card, index) => {

    let json_main_produtc_obect = {}
    let json_main_produtc_image = {}
    let json_main_produtc_Veredelung = {}
      
      const imageWrapper = card.querySelector('.selected-product-image');
      const quantityInput = card.querySelector('.quantity__input');
      const colle_url = card.querySelector('.edit-product')?.getAttribute('data-collection-url') || '';
      const page_url = card.querySelector('.edit-product')?.getAttribute('href') || '';
      const main_json_objct =  card.querySelector('[data-customize')?.getAttribute('data-customize') || null;
      const main_json_image =  card.querySelector('[data-customize-final-images')?.getAttribute('data-customize-final-images') || null;
      const main_json_Veredelung =  card.querySelector('[data-customize-final-Veredelung')?.getAttribute('data-customize-final-Veredelung') || null;
      
      if(main_json_objct){
         json_main_produtc_obect = JSON.parse(main_json_objct);
      }
      if(main_json_image){
         json_main_produtc_image = main_json_image;
      }
      if(main_json_Veredelung){
            // json_main_produtc_Veredelung = main_json_Veredelung
            json_main_produtc_Veredelung = JSON.parse(main_json_Veredelung); 
      }

      const productData = {
        id: index + 1,
        kategorynam: imageWrapper?.getAttribute('data-collection-title') || '',
        varent_id: imageWrapper?.getAttribute('data-variant-id') || '',
        product_heandle: imageWrapper?.getAttribute('data-product-handle') || '',
        qtu: quantityInput?.value || '',
        customize_id: imageWrapper?.getAttribute('data-prosnolize-id') || '',
        collection_url : colle_url,
        page_url: page_url,
        product_custom_image: json_main_produtc_image || null,
        product_custom_oject: json_main_produtc_obect || null,
         product_custom_Veredelung: json_main_produtc_Veredelung || null,
      };

      updatedSet[(index + 1).toString()] = productData;
    });

    // Replace old set with the updated one
    existingData[setIndex] = updatedSet;

    // Save to localStorage
    localStorage.setItem("customProductSets", JSON.stringify(existingData));


    // Optional: upload
    if (typeof people_data_upload === 'function') {
      people_data_upload(existingData, metfilds_key);
    }
     const successmess = document.querySelector('.popup-success');
    if (successmess) {
    
    
      // Hide the popup after 3 seconds (3000 milliseconds)
      setTimeout(() => {
          successmess.classList.add('active');
      }, 2000);
    }
  }
});


// ==================copy button click====
const copybtns = document.querySelectorAll('.btn-copy');

copybtns.forEach(btn => {
  btn.addEventListener('click', function () {
    const closestInfo = btn.closest('.curated-outfit-product-info');
    const editBtn = closestInfo.querySelector('.btn-edit');
    const setName = editBtn.getAttribute('data-set-name');
    const randomId = Math.floor(Math.random() * 1000000);
    const metfilds_key = 'outfit';

    const newSet = {
      id: randomId,
      name: setName
    };

    const copyItem = btn.closest('.grid__item.curated-outfit-product-item');
    const allImgs = copyItem.querySelectorAll('.curated-outfit-product-image .selected-product-card');

    if (!allImgs.length) return;

    allImgs.forEach((img, index) => {
     const productCard =  img.querySelector('.selected-product-image');
      const variantId = productCard.getAttribute('data-variant-id') || '';
      const collectionTitle = productCard.getAttribute('data-collection-title') || '';
      const productHandle = productCard.getAttribute('data-product-handle') || '';
      const quantityInput = img.querySelector('.quantity__input');
      const quantity = quantityInput?.value || '';

      const productData = {
        id: index + 1,
        kategorynam: collectionTitle,
        varent_id: variantId,
        product_heandle: productHandle,
        qtu: quantity
      };

      newSet[(index + 1).toString()] = productData;
    });

    const existingSets = JSON.parse(localStorage.getItem('customProductSets')) || [];
    existingSets.push(newSet); // 👈 adds to last
    localStorage.setItem('customProductSets', JSON.stringify(existingSets));

    
    // Optional upload
    console.log("existingSets",existingSets,metfilds_key)
    people_data_upload(existingSets, metfilds_key,true);
  });
});

// const deleteButtons = document.querySelectorAll('.curated-outfit-product-action .btn-delete');

// deleteButtons.forEach(button => {
//   button.addEventListener('click', function () {
//     console.log(deleteButtons,'deleteButtons');
//     const setIdToDelete = this.getAttribute('data-set-id-delete');
//     const metfilds_key = 'outfit'; // or dynamically set this if needed

//     if (!setIdToDelete) return;

//     const existingData = JSON.parse(localStorage.getItem('customProductSets')) || [];

//     const updatedData = existingData.filter(item => item.id.toString() !== setIdToDelete.toString());

//     // Update localStorage
//     localStorage.setItem('customProductSets', JSON.stringify(updatedData));

//     // Now call your function with the updated JSON
//     people_data_upload(updatedData, metfilds_key);
//     const cardToRemove = this.closest('.grid__item.curated-outfit-product-item');
//     if (cardToRemove) cardToRemove.remove();

//   });
// });



//======== pepal remove function

function person_remove(this_element,id){
  if (!id) return;
  const metfilds_key = 'person';
  const existingData = JSON.parse(localStorage.getItem('peopel_data')) || [];

    const updatedData = existingData.filter(item => item.id.toString() !== id.toString());
     localStorage.setItem('peopel_data', JSON.stringify(updatedData));
     console.log(updatedData,metfilds_key)
     people_data_upload(updatedData, metfilds_key);
     const cardToRemove = this_element.closest('.people-cards-item');
    if (cardToRemove) cardToRemove.remove();
}



function person_remove_popup(this_element,id){
  if (!id) return;
  const popup_content = this_element.closest('.people-cards-item');
  if(popup_content){
    const con_popup = popup_content.querySelector('[person_popup_main]');
      if(con_popup){
        con_popup.classList.remove("hidden");
        document.body.classList.add("person_remove_popup");
      }
  }
  
}

function person_remove_popup_close(this_element,id){
  const popup_content = this_element.closest('[person_popup_main]');
  if(popup_content){
    popup_content.classList.add("hidden");
    document.body.classList.remove("person_remove_popup");
  }
}


// =====================outfit delet function 
  function outfit_remove(this_element,id){
    if (!id) return;
    const metfilds_key = 'outfit';
    const existingData = JSON.parse(localStorage.getItem('customProductSets')) || [];

      const updatedData = existingData.filter(item => item.id.toString() !== id.toString());
      localStorage.setItem('customProductSets', JSON.stringify(updatedData));
       console.log(updatedData,metfilds_key)
      people_data_upload(updatedData, metfilds_key);
      const cardToRemove = this_element.closest('.curated-outfit-product-item');
      if (cardToRemove) cardToRemove.remove();
      document.body.classList.remove("person_remove_popup");
      
  }



  function outfit_remove_popup(this_element,id){
    if (!id) return;
    const popup_content = this_element.closest('.curated-outfit-product-item');
    if(popup_content){
      const con_popup = popup_content.querySelector('[person_popup_main]');
        if(con_popup){
          con_popup.classList.remove("hidden");
          document.body.classList.add("person_remove_popup");
        }
    }
    
  }

  function outfit_remove_popup_close(this_element,id){
    const popup_content = this_element.closest('[person_popup_main]');
    if(popup_content){
      popup_content.classList.add("hidden");
      document.body.classList.remove("person_remove_popup");
    }
  }


// ========== add to cart product 
function checkOutOfStockMessage() {
  document.querySelectorAll('.people_popup select').forEach(select => {
    const selectedOption = select.options[select.selectedIndex];
    const row = select.closest('[data-outfit-product-row]');
    const titleCell = row?.querySelector('.outfit-order-grid__title');

    // Remove existing out-of-stock message if any
    const nextEl = select.parentNode.querySelector('.out-of-stock-msg');
    if (nextEl) nextEl.remove();
    const titleMessage = titleCell?.querySelector('.out-of-stock-msg');
    if (titleMessage) titleMessage.remove();
    const sizeMatchMessage = titleCell?.querySelector('.outfit-size-match-msg');
    if (sizeMatchMessage) sizeMatchMessage.remove();

    if (selectedOption.disabled) {
      const message = document.createElement('p');
      message.classList.add('out-of-stock-msg');
      const textget = document.querySelector('body');
      message.textContent = 'Dieser Artikel ist in der gewünschten Größe aktuell nicht vorrätig.';
      if (titleCell) {
        titleCell.appendChild(message);
      } else {
        select.parentNode.appendChild(message);
      }
  }
});
}

function showOutfitSizeMatchWarning(row, sizeValue) {
  const titleCell = row?.querySelector('.outfit-order-grid__title');
  if (!titleCell) return;

  const existingMessage = titleCell.querySelector('.outfit-size-match-msg');
  if (existingMessage) existingMessage.remove();

  const message = document.createElement('p');
  message.className = 'outfit-size-match-msg out-of-stock-msg';
  message.textContent = `Artikel in Größe ${sizeValue} nicht verfügbar.`;
  titleCell.appendChild(message);
}

// Initial check on page load
checkOutOfStockMessage();

// Add event listener on select change
const peopleSelects = document.querySelectorAll('.people_popup .field__select-outfit');
if (peopleSelects.length > 0) {
 peopleSelects.forEach(select => {
    select.addEventListener('change', checkOutOfStockMessage);
  });
}


const people_popupA = document.querySelectorAll('.people_popup .close');

people_popupA.forEach(elem => {
  elem.addEventListener('click', function () {
    const popupElement = elem.closest('.people_popup');
    if (popupElement) {
        document.body.classList.remove('overflow-hidden');
      popupElement.classList.remove('people_popup_show');
    }
  });
});

document.body.addEventListener("click", function(event) {
  const target = event.target;

  if (
    target.classList.contains('people_popup-form-wrapper') ||
    target.classList.contains('people_popup-form-inner')
  ) {
    const popupElements = document.querySelectorAll('.people_popup');
    
    popupElements.forEach(popup => {
      popup.classList.remove('people_popup_show'); // ✅ Correct element here
    });

    document.body.classList.remove("overflow-hidden");
  }
});







function normalizeOutfitOrderKey(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '');
}

function getPersonSizeValueForOutfitCategory(categoryId, personData) {
  if (!categoryId || !personData) return '';

  const normalizedPersonData = {};
  Object.keys(personData).forEach((key) => {
    normalizedPersonData[normalizeOutfitOrderKey(key)] = personData[key];
  });

  const normalizedCategory = normalizeOutfitOrderKey(categoryId);
  const keyGroups = [
    { match: ['hemd', 'hemden', 'bluse', 'blusen'], keys: ['hemd'] },
    { match: ['polo', 'poloshirt', 'poloshirts'], keys: ['poloshirts', 'poloshirt'] },
    { match: ['tshirt', 'tshirts', 'shirt'], keys: ['tshirts', 'shirt'] },
    { match: ['hose', 'hosen', 'pants', 'trouser', 'trousers'], keys: ['hosen', 'hose', 'pants'] },
    { match: ['schuh', 'schuhe', 'shoe', 'shoes', 'sicherheitsschuh', 'sicherheitsschuhe'], keys: ['schuhe', 'shoes'] },
    { match: ['softshell'], keys: ['softshelljacken', 'softshelljacke'] },
    { match: ['sweatshirt'], keys: ['sweatshirts', 'sweatshirt'] },
    { match: ['pullover'], keys: ['pullover'] },
    { match: ['weste', 'westen', 'bodywarmer'], keys: ['westen', 'weste'] },
    { match: ['jacke', 'jacken'], keys: ['jacken', 'jacke'] },
  ];

  const matchedGroup = keyGroups.find((group) =>
    group.match.some((term) => normalizedCategory.includes(term))
  );

  if (!matchedGroup) return '';

  const matchedKey = matchedGroup.keys.find((key) => normalizedPersonData[key] != null && normalizedPersonData[key] !== '');
  return matchedKey ? String(normalizedPersonData[matchedKey]) : '';
}

function normalizeOutfitSizeValue(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/[^a-z0-9/.-]+/g, '');
}

function getOutfitSizeCandidates(value) {
  const rawValue = String(value || '').trim();
  const normalizedValue = normalizeOutfitSizeValue(rawValue);
  const parts = rawValue
    .split(/[\/|,;()\-–—]+/)
    .map((part) => normalizeOutfitSizeValue(part))
    .filter(Boolean);
  const digitMatches = rawValue.match(/\d+/g) || [];
  const letterMatches = rawValue.match(/(?:[2345]?x(?:s|l)|xs|s|m|l|xl|xxl|xxxl|xxxxl)/gi) || [];
  const normalizedDigits = digitMatches.map((match) => normalizeOutfitSizeValue(match));
  const normalizedLetters = letterMatches.map((match) => normalizeOutfitSizeValue(match));

  return Array.from(new Set([
    normalizedValue,
    ...parts,
    ...normalizedDigits,
    ...normalizedLetters,
  ].filter(Boolean)));
}

function findMatchingOutfitSizeOption(select, sizeValue) {
  const sizeCandidates = getOutfitSizeCandidates(sizeValue);

  return Array.from(select.options).find((option) => {
    const optionCandidates = getOutfitSizeCandidates(option.dataset.option1 || option.textContent || option.value);

    return sizeCandidates.some((sizeCandidate) =>
      optionCandidates.some((optionCandidate) =>
        optionCandidate === sizeCandidate
        || optionCandidate.startsWith(sizeCandidate)
        || sizeCandidate.startsWith(optionCandidate)
      )
    );
  });
}

function applyPersonSizesToOutfitPopup(dropdown) {
  const selectedOption = dropdown.selectedOptions && dropdown.selectedOptions[0];
  const personJson = selectedOption?.dataset.personJson;
  const popupRoot = dropdown.closest('[data-outfit-order-form]');
  if (!popupRoot) return;

  let personData = null;
  if (personJson) {
    try {
      personData = JSON.parse(personJson);
    } catch (error) {
      personData = null;
    }
  }

  popupRoot.querySelectorAll('[data-outfit-product-row]').forEach((row) => {
    const categoryId = row.getAttribute('data-category-id');
    const categoryLabel = row.querySelector('.outfit-order-grid__label')?.textContent || '';
    const sizeValue = getPersonSizeValueForOutfitCategory(`${categoryId} ${categoryLabel}`, personData);
    const select = row.querySelector('.field__select-outfit');
    const existingMessage = row.querySelector('.outfit-size-match-msg');
    if (existingMessage) existingMessage.remove();

    if (!select || !sizeValue) return;

    const matchingOption = findMatchingOutfitSizeOption(select, sizeValue);

    if (!matchingOption) {
      console.warn('WWM outfit size match missing', {
        categoryId,
        categoryLabel,
        sizeValue,
        sizeCandidates: getOutfitSizeCandidates(sizeValue),
        options: Array.from(select.options).map((option) => ({
          text: option.textContent,
          value: option.value,
          option1: option.dataset.option1,
          disabled: option.disabled,
        })),
      });
      console.warn(`WWM outfit size match missing: ${categoryLabel || categoryId} -> ${sizeValue}`);
      showOutfitSizeMatchWarning(row, sizeValue);
      return;
    }

    select.value = matchingOption.value;
    Array.from(select.options).forEach((option) => {
      option.toggleAttribute('selected', option.value === matchingOption.value);
    });
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

function syncOutfitQtyDisplay(qtyInput) {
  const qtyControl = qtyInput?.closest('.outfit-order-grid__qty-control');
  const qtyDisplay = qtyControl?.querySelector('[data-outfit-qty-display]');
  if (!qtyDisplay || !qtyInput) return;

  const normalizedValue = Math.max(1, parseInt(qtyInput.value || '1', 10));
  qtyInput.value = normalizedValue;
  qtyDisplay.textContent = normalizedValue;
}

const btnatc = document.querySelectorAll('.btn-atc button');

btnatc.forEach(btn => {
  btn.addEventListener('click', function () {
    const copyItem = btn.closest('.grid__item.curated-outfit-product-item');
    const people_popupadd = copyItem?.querySelector('.people_popup');
    if (!people_popupadd) return;

    document.body.classList.add('overflow-hidden');
    people_popupadd.classList.add("people_popup_show");

    const peopleDropdown = people_popupadd.querySelector('[data-outfit-person-select]');
    if (peopleDropdown) {
      peopleDropdown.value = '';
      peopleDropdown.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
});

const outfitSelects = document.querySelectorAll('.people_popup [data-outfit-person-select]');

if (outfitSelects.length > 0) {
  outfitSelects.forEach(dropdown => {
    dropdown.addEventListener('change', function() {
      applyPersonSizesToOutfitPopup(dropdown);
    });
  });
}

function buildOutfitNote(outfitNote, selectedPerson) {
  const noteParts = [];
  const trimmedOutfitNote = outfitNote ? outfitNote.trim() : '';
  const departmentNumber = typeof selectedPerson?.['abteilung-personalnummer'] === 'string'
    ? selectedPerson['abteilung-personalnummer'].trim()
    : '';

  if (trimmedOutfitNote) {
    noteParts.push(trimmedOutfitNote);
  }

  if (departmentNumber) {
    noteParts.push(`Abteilung/Personalnummer: ${departmentNumber}`);
  }

  return noteParts.join(' | ');
}

function initPeopleFilters() {
  const filterRoot = document.querySelector('[data-people-filters]');
  const cardsGrid = document.querySelector('.people-cards-grid');
  if (!filterRoot || !cardsGrid) return;

  const peopleSection = filterRoot.closest('.people-cards') || document;
  const searchInput = filterRoot.querySelector('[data-people-filter-search]');
  const outfitSelect = filterRoot.querySelector('[data-people-filter-outfit]');
  const countElement = peopleSection.querySelector('[data-people-filter-count]');
  const cards = Array.from(cardsGrid.querySelectorAll('.people-cards-item'));

  if (!cards.length) return;

  function updatePeopleFilters() {
    const searchValue = (searchInput?.value || '').trim().toLowerCase();
    const outfitValue = (outfitSelect?.value || '').trim().toLowerCase();
    let visibleCount = 0;

    cards.forEach((card) => {
      const searchHaystack = (card.getAttribute('data-person-search') || '').toLowerCase();
      const outfitName = (card.getAttribute('data-person-outfit-name') || '').toLowerCase();
      const outfitId = (card.getAttribute('data-person-outfit-id') || '').trim();

      const matchesSearch = !searchValue || searchHaystack.includes(searchValue);
      const matchesOutfit = !outfitValue
        || (outfitValue === '__none__' ? !outfitId : outfitName === outfitValue);

      const isVisible = matchesSearch && matchesOutfit;
      card.hidden = !isVisible;

      if (isVisible) {
        visibleCount += 1;
      }
    });

    if (countElement) {
      countElement.textContent = `${visibleCount} Mitarbeiter`;
    }
  }

  searchInput?.addEventListener('input', updatePeopleFilters);
  outfitSelect?.addEventListener('change', updatePeopleFilters);
  updatePeopleFilters();
}

document.querySelectorAll('[data-outfit-qty-input]').forEach((qtyInput) => {
  syncOutfitQtyDisplay(qtyInput);
  qtyInput.addEventListener('input', function () {
    syncOutfitQtyDisplay(qtyInput);
  });
});

document.addEventListener('click', function (event) {
  const qtyButton = event.target.closest('[data-outfit-qty-increment], [data-outfit-qty-decrement]');
  if (!qtyButton) return;

  const qtyControl = qtyButton.closest('.outfit-order-grid__qty-control');
  const qtyInput = qtyControl?.querySelector('[data-outfit-qty-input]');
  if (!qtyInput) return;

  const currentValue = Math.max(1, parseInt(qtyInput.value || '1', 10));
  const nextValue = qtyButton.hasAttribute('data-outfit-qty-increment')
    ? currentValue + 1
    : Math.max(1, currentValue - 1);

  qtyInput.value = nextValue;
  syncOutfitQtyDisplay(qtyInput);
  qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
});

const submitButtons = document.querySelectorAll('.submit__buttont button');

if (submitButtons.length > 0) {
  submitButtons.forEach(submitBtn => {
    submitBtn.addEventListener('click', function () {
      const formEl = submitBtn.closest('form');
      const errorText = submitBtn.getAttribute('data-error-text') || 'Bitte Auswahl pruefen.';
      const errorElement = submitBtn.parentElement?.querySelector('.outfit-outstock-error-mess');
      const popupRoot = this.closest('.people_popup') || this.closest('.people_popup-form-inner') || this.closest('[data-outfit-order-form]');
      const editWrapper = this.closest('[data-outfit-order-form]') || popupRoot;
      if (!editWrapper) return;

      if (errorElement) {
        errorElement.textContent = '';
      }

      const itemsToAdd = [];
      let allValid = true;
      const existingData = JSON.parse(localStorage.getItem('customProductSets')) || [];
      const personDropdown = editWrapper.querySelector('[data-outfit-person-select]') || popupRoot?.querySelector('[data-outfit-person-select]');
      const noteField = editWrapper.querySelector('[data-outfit-note]') || popupRoot?.querySelector('[data-outfit-note]');
      const outfitNote = noteField?.value?.trim() || '';
      const selectedPersonOption = personDropdown?.selectedOptions?.[0];
      let selectedPerson = null;
      const productRows = Array.from(
        editWrapper.querySelectorAll('[data-outfit-product-row]').length
          ? editWrapper.querySelectorAll('[data-outfit-product-row]')
          : popupRoot?.querySelectorAll('[data-outfit-product-row]') || []
      );

      if (selectedPersonOption?.dataset.personJson) {
        try {
          selectedPerson = JSON.parse(selectedPersonOption.dataset.personJson);
        } catch (error) {
          selectedPerson = null;
        }
      }

      productRows.forEach((row) => {
        const select = row.querySelector('.field__select-outfit');
        const staticInput = row.querySelector('[data-static-variant-id]');
        const qtyInput = row.querySelector('[data-outfit-qty-input]');
        const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10));
        const dataoutfit = row.getAttribute('data-outfit-id');
        const productHandlee = row.getAttribute('data-product-handle');

        let variantId = null;
        let dataprice = 0;

        if (select) {
          const selectedOption = select.options[select.selectedIndex];
          if (
            !selectedOption ||
            selectedOption.value === '' ||
            !selectedOption.hasAttribute('data-variant-id') ||
            selectedOption.disabled
          ) {
            allValid = false;
            select.classList.add('select-error');
            return;
          }

          select.classList.remove('select-error');
          variantId = selectedOption.getAttribute('data-variant-id');
          dataprice = Number(selectedOption.getAttribute('data-meta-price')) || 0;
        } else if (staticInput) {
          variantId = staticInput.getAttribute('data-static-variant-id');
          dataprice = Number(staticInput.getAttribute('data-static-price')) || 0;
        }

        if (!variantId) {
          allValid = false;
          return;
        }

        const matchedSet = existingData.find(item =>
          item.id && dataoutfit && item.id.toString() === dataoutfit.toString()
        );

        let productJson = null;

        if (matchedSet) {
          Object.keys(matchedSet).forEach(key => {
            if (!isNaN(key)) {
              const prod = matchedSet[key];
              if (!prod) return;

              if (prod.varent_id && variantId && prod.varent_id.toString() === variantId.toString()) {
                productJson = prod;
              } else if (
                !productJson &&
                prod.product_heandle &&
                productHandlee &&
                prod.product_heandle.toString() === productHandlee.toString()
              ) {
                productJson = prod;
              }
            }
          });
        }

        const itemToAdd = {
          id: variantId,
          quantity,
          properties: {}
        };

        const item_main_serlect_custom = productJson
          ? selectedproducts.find(item => Number(item.id) === Number(productJson.customize_id))
          : null;

        let totalPriceSKU = 0;
        if (item_main_serlect_custom != null && productJson) {
          let obj = productJson.product_custom_oject;
          let veredelungObj = productJson.product_custom_Veredelung;
          let subImages = item_main_serlect_custom.sub_images;
          const mainId = item_main_serlect_custom.id;
          let indexCounter = 1;

          Object.keys(obj).forEach(keyId => {
            const jsonString = productJson.product_custom_oject[keyId];
            const isValid = hasavalable(jsonString);
            if (!isValid === true) return;

            let combinedKey = mainId + "_&&_" + keyId;
            if (!veredelungObj.hasOwnProperty(combinedKey)) return;

            let matchedValue = veredelungObj[combinedKey];
            let index = parseInt(keyId);
            if (!subImages[index]) return;

            let label = subImages[index].label;
            let sku = "";
            let price = "";
            let type = matchedValue;

            if (matchedValue === "Stick") {
              sku = subImages[index].sku;
              price = subImages[index].price;
            }
            if (matchedValue === "Druck") {
              sku = subImages[index].sku_Druck;
              price = subImages[index].price_Druck;
            }
            if (!sku) return;

            totalPriceSKU += price / 100;

            itemToAdd.properties[`Label ${indexCounter}`] = label;
            itemToAdd.properties[`Type ${indexCounter}`] = type;
            itemToAdd.properties[`SKU_${type} ${indexCounter}`] = sku;
            itemToAdd.properties[`Price_${type} ${indexCounter}`] = price;
            indexCounter++;
          });
        }

        if (selectedPerson) {
          const firstName = selectedPerson.vorname || '';
          const lastName = selectedPerson.nachname || '';
          itemToAdd.properties["Mitarbeiter"] = `${firstName} ${lastName}`.trim();
          if (selectedPerson.id) {
            itemToAdd.properties["Person ID"] = selectedPerson.id;
          }
        }

        const combinedOutfitNote = buildOutfitNote(outfitNote, selectedPerson);
        if (combinedOutfitNote) {
          itemToAdd.properties["Produktnotiz"] = combinedOutfitNote;
        }

        let finalImages = [];
        if (productJson?.product_custom_image?.length > 0) {
          finalImages = JSON.parse(productJson.product_custom_image);
        }
        if (productJson) {
          itemToAdd.properties["_product_custom_image"] = JSON.stringify(finalImages);
          itemToAdd.properties["_product_json"] = JSON.stringify(productJson);
        }

        itemsToAdd.push(itemToAdd);
      });

      if (!allValid) {
        if (errorElement) {
          errorElement.textContent = errorText;
        }
        return;
      }

      if (itemsToAdd.length > 0) {
        let errorElementNOne = formEl?.querySelector('.custom-error-message');
        if(errorElementNOne){
          errorElementNOne.style.display = 'none';
        }

        document.body.classList.add('cart-adding');
        addToCart(itemsToAdd, submitBtn);
      } else if (errorElement) {
        errorElement.textContent = 'Keine gueltigen Outfit-Artikel fuer den Warenkorb gefunden.';
      }
    });
  });
}

initPeopleFilters();




function addToCart(items, submitBtn) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ items })
  })
  .then(response => response.json())
  .then(data => {
    if (data.status) {
      console.error('Error adding to carttttt:', data);
       document.body.classList.remove('cart-adding');
      const error_mess = submitBtn?.parentElement?.querySelector('.outfit-outstock-error-mess');
    if (error_mess) {
      error_mess.innerHTML = data.message || 'Something went wrong.';
    }
    } else {
      document.body.classList.remove('cart-adding'); 
      const this_cartDrawer = document.querySelector('cart-drawer');
      if (this_cartDrawer?.refresh) {
        this_cartDrawer.refresh(true);
      }
    }
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    document.body.classList.remove('cart-adding');

    
  });
}
// ----------- out of stock close
const closePopupEls = document.querySelectorAll('.popup-overlay-inner, .popup-outofstock-inner .close');
if (closePopupEls) {
  
closePopupEls.forEach(el => {
  el.addEventListener('click', function () {
    const popupDiv = document.querySelector('.popup-outofstock');
    popupDiv.classList.remove('active');
    document.querySelector('body').classList.remove('outofstock-popup-show');
  });
});
}



const tabButtons = document.querySelectorAll('.editor_section .tab_field_hide');

if (tabButtons.length > 0) {
  tabButtons.forEach(tab => {
    tab.addEventListener('click', function (e) {
      e.preventDefault();

      // Get href target (e.g., #upload_own)
      const targetId = this.getAttribute('href');

      // Remove 'active' class from all tab-panes
      document.querySelectorAll('.editor_section .tab_field_show').forEach(pane => {
        pane.classList.remove('active');
      });

      // Remove 'active' class from all tab <li>
      document.querySelectorAll('.editor_section #tabs li').forEach(tabLi => {
        tabLi.classList.remove('active');
      });

      // Add 'active' to current tab <li>
      this.closest('li').classList.add('active');

      // Add 'active' to matching tab-pane
      const targetPane = document.querySelector(targetId);
      if (targetPane) {
        targetPane.classList.add('active');
      }
    });
  });
}




// document.addEventListener("DOMContentLoaded", async function () {
//   const filterSections = document.querySelectorAll("filter-section");

//   for (const section of filterSections) {
//     const collectionUrl = section.getAttribute("data-collection-url");
//     if (!collectionUrl) continue;

//     const fetchUrl = `${collectionUrl}?view=wwm`;
//     console.log(fetchUrl, "fetchUrl");

//     try {
//       const res = await fetch(fetchUrl);

//       if (!res.ok) {
//         console.error(`❌ Fetch failed for ${fetchUrl}: ${res.status} ${res.statusText}`);
//         continue; // skip to next section if this one fails
//       }

//       const htmlText = await res.text();
//       const tempDiv = document.createElement("div");
//       tempDiv.innerHTML = htmlText;
//       const fetchedDiv = tempDiv.querySelector("div[id$='custom_filter']");
 

//       const targetDiv = section.querySelector(`#${fetchedDiv.id}`);
//       if (targetDiv) {
//             targetDiv.innerHTML = fetchedDiv.innerHTML;
//       }


//       console.log(`✅ Filter updated for: ${collectionUrl}`);
//     } catch (err) {
//       console.error(`❌ Error fetching filter for ${collectionUrl}:`, err);
//       // only log error, no throw
//     }
//   }
// });




class CustomFacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.collectionUrl = this.getAttribute("data-collection-url") || null;
    if (!this.collectionUrl) return;

    this.init();
  }

  async init() {
    const fetchUrl = `${this.collectionUrl}?view=wwm`;
   this.res =  await this.fetchFilterData(fetchUrl);
   if (!this.res.ok) {
      console.error(`❌ Fetch failed for ${fetchUrl}: ${res.status} ${res.statusText}`);
      return;
    }

      const htmlText = await this.res.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlText;

      const fetchedDiv = tempDiv.querySelector("div[id$='custom_filter']");
      if (!fetchedDiv) {
        console.warn(`⚠️ No custom_filter div found in ${fetchUrl}`);
        return;
      }

      const targetDiv = this.querySelector(`#${fetchedDiv.id}`);
      if (targetDiv) {
        targetDiv.innerHTML = fetchedDiv.innerHTML;
        console.log(`✅ Filter updated for: ${this.collectionUrl}`);
      } else {
        console.warn(`⚠️ Target div not found for ID: ${fetchedDiv.id}`);
      }

  }
  async fetchFilterData(url) {
    // 🔹 Dedicated async function for fetching
    console.log(`🌐 Fetching filter from: ${url}`);
    return await fetch(url);
  }
}

// Define custom element
customElements.define('filter-section', CustomFacetFiltersForm);

// class CollectionFilteCustom extends HTMLElement {
//   constructor() {
//     super();
//     this.initialize();
//   }

//   initialize() {
//     this.form = this.querySelector('form');
//     if (!this.form) return;

//     // Bind method once
//     this.onInputChange = this.onInputChange.bind(this);

//     // Add listeners to inputs/selects
//     this.form.querySelectorAll('input, select').forEach((input) => {
//       input.addEventListener('change', this.onInputChange);
//     });
//   }

//   async onInputChange(event) {
//     event.preventDefault();
//     const currentUrle = this.getAttribute('data-new-collection-url');
//     console.log(currentUrle,event, "current clicked url");

   
    

//     const formData = new FormData(this.form);
//     const queryString = new URLSearchParams(formData).toString();

//     const currentUrl = this.form.action;
//     const wrapper = this.closest('filter-section') || this;

//     const filterParams = currentUrl.includes('?')
//       ? currentUrl.split('?')[1]
//       : queryString;

//     const baseCollectionUrl =
//       wrapper.getAttribute('data-collection-url') || this.dataset.collectionUrl;
//     const fetchUrl = `${baseCollectionUrl}?view=wwm&${filterParams}`;


//     const productdiv = this.closest('.new-outfit-collection-wrapper');
    

//     try {
//       const response = await fetch(fetchUrl);
//       if (!response.ok) throw new Error("Network response was not ok");

//       const htmlText = await response.text();
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(htmlText, 'text/html');

//       const newSection = doc.querySelector('collection-filte-custom');
//       const productnewSection = doc.querySelector('.new-outfit-collection-grid');

//       if (newSection) {
//         // ✅ Update only the inner HTML
//         wrapper.querySelector('collection-filte-custom').innerHTML = newSection.innerHTML;

//         // ✅ Update product grid
//         if (productdiv && productnewSection) {
//           productdiv.querySelector('.new-outfit-collection-grid').innerHTML =
//             productnewSection.innerHTML;
//         }

//          // get all buttons
//       //     const urlcheck = document.querySelectorAll('.new-outfit-card-info .btn-html-add');

//       //     urlcheck.forEach(el => {
//       //       const outfitName = el.getAttribute('data-new-outfit-name');

//       //       console.log("Checking:", outfitName);
//       // console.log(outfitName,'outfitName')
//       //       // MATCH CONDITION
//       //       if (outfitName === currentUrle) {
//       //         console.log(el,"el");

//       //         el.setAttribute('disabled', "disabled");
//       //         el.classList.add('disabled-btn'); // optional styling
//       //       }
//       //     });
//         // ✅ Re-bind events to new form elements
//         this.initialize();

//         console.log("✅ Updated and re-initialized collection-filte-custom");
//       } 
//     } catch (error) {
//       console.error("❌ Fetch failed:", error);
//     }
//   }
// }

// customElements.define('collection-filte-custom', CollectionFilteCustom);

class CollectionFilteCustom extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.onInputChange = this.onInputChange.bind(this);

    this.form.querySelectorAll('input, select').forEach((input) => {
      input.removeEventListener('change', this.onInputChange);
      input.addEventListener('change', this.onInputChange);
    });
  }

  async onInputChange(event) {
    event.preventDefault();

    const formData = new FormData(this.form);
    const queryString = new URLSearchParams(formData).toString();

    const baseCollectionUrl =
      this.getAttribute('data-collection-url') || this.dataset.collectionUrl;

    const fetchUrl = `${baseCollectionUrl}?view=wwm&${queryString}`;

    const productWrapper = this.closest('.new-outfit-collection-wrapper');

    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error('Network error');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // 🔹 IMPORTANT: Update SAME component only
      const newFilter = doc.querySelector('collection-filte-custom');
      const newProducts = doc.querySelector('.new-outfit-collection-grid');

      if (newFilter) {
        this.innerHTML = newFilter.innerHTML;
      }

      if (productWrapper && newProducts) {
        productWrapper.querySelector('.new-outfit-collection-grid').innerHTML =
          newProducts.innerHTML;
      }

      // 🔁 Re-bind events for THIS component
      this.initialize();

    } catch (err) {
      console.error('❌ Filter fetch error:', err);
    }
  }
}

customElements.define('collection-filte-custom', CollectionFilteCustom);






const outfitclosesuccs = document.querySelectorAll('.popup-outfit-name .popup-overlay-inner ,.popup-outfit-name .close');
if (outfitclosesuccs) {
  
outfitclosesuccs.forEach(el => {
  el.addEventListener('click', function () {
    const outfitpopupDiv = document.querySelector('.popup-outfit-name');

    outfitpopupDiv.classList.remove('active');
    document.querySelector('body').classList.remove('popup-outfit-name-show');

  });
});
}
